import { haversineDistance } from "./haversine-distance.js";

//#region src/utils/distance/geolocation-distance.ts
/**
* Calculates the haversine distance between geolocation points A and B.
* @param { latitude: number; longitude: number } coordA { latitude, longitude } point A
* @param { latitude: number; longitude: number } coordB { latitude, longitude } point B
*/
const geolocationDistance = ({ latitude, longitude }, { latitude: latitude2, longitude: longitude2 }) => haversineDistance([latitude, longitude], [latitude2, longitude2]);

//#endregion
export { geolocationDistance };